import React from 'react';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { IconBadge, iconBadgeSizes } from '@components/IconBadge';

import styles from './SettingsPanelHeader.module.scss';

export const SettingsPanelHeader = ({
  icon,
  iconBg = 'indigo-100',
  title,
  description,
  rightSlot,
}) => (
  <div className={styles.panelHeader}>
    <IconBadge size={iconBadgeSizes.lg} bg={iconBg} icon={icon} />
    <div className={styles.headerText}>
      <Text
        variant={textVariantsEnum.Text_xl}
        fontWeight={fontWeightEnum.Semibold}
        color="gray-900"
      >
        {title}
      </Text>
      {description && (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Normal}
          color="gray-600"
        >
          {description}
        </Text>
      )}
    </div>
    {rightSlot && <div className={styles.rightSlot}>{rightSlot}</div>}
  </div>
);

SettingsPanelHeader.displayName = 'SettingsPanelHeader';
